(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artesania"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   Artesanía — scroll engine. Ported from the rendered prototype:
   header-less (theme provides header); single rAF loop drives reveals, the
   intro framed-video travel (40vw -> 80vw to centre + text fade + overlay),
   and the proceso phase switching + plate scroll-rotation + closing.
   Re-inits on shopify:section:load. Math.max guards, reduced-motion fallback.
   ============================================================================ */
(function () {
  function clamp01(t) { return Math.max(0, Math.min(1, t)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function smoothstep(t) { return t * t * (3 - 2 * t); }

  function init(root) {
    if (!root || root.dataset.apInit) return;
    root.dataset.apInit = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = function () { return window.matchMedia('(max-width: 780px)').matches; };

    /* ---- lazy-load the Three.js plate when proceso nears viewport ----
       Ships as injected assets (three + textures then plate) to dodge
       theme-check AssetSizeJavaScript / ParserBlockingJavaScript. Under
       reduced-motion we skip the ~2 MB entirely and show the static plate. */
    var procesoEl = root.querySelector('[data-ap-proceso]');
    var plateFb = root.querySelector('.plate-fallback');
    var booted = false;
    function loadScript(src) {
      return new Promise(function (res, rej) {
        var s = document.createElement('script');
        s.src = src; s.onload = res; s.onerror = rej;
        document.head.appendChild(s);
      });
    }
    function bootPlate() {
      if (booted) return; booted = true;
      window.LCPlateModel = root.dataset.modelSrc;
      loadScript(root.dataset.threeSrc)
        .then(function () { return loadScript(root.dataset.loaderSrc); })
        .then(function () { return loadScript(root.dataset.plateSrc); })
        .catch(function () { if (plateFb) plateFb.classList.add('show'); });
    }
    if (reduce) {
      if (plateFb) plateFb.classList.add('show');
    } else if (procesoEl) {
      if ('IntersectionObserver' in window) {
        var plObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { bootPlate(); plObs.disconnect(); } });
        }, { rootMargin: '600px 0px' });
        plObs.observe(procesoEl);
      } else { bootPlate(); }
    }

    /* ---- HERO video: seek to ~3s, autoplay muted, fade in ---- */
    var hero = root.querySelector('[data-ap-hero]');
    var heroVideo = root.querySelector('.ap-hero__video');
    if (heroVideo && hero) {
      var START = parseFloat(heroVideo.dataset.start || '0');
      var startAt = function () { try { if (START && heroVideo.duration > START) heroVideo.currentTime = START; } catch (e) {} };
      heroVideo.addEventListener('loadedmetadata', startAt);
      heroVideo.addEventListener('timeupdate', function () { if (START && heroVideo.currentTime < START - 0.05) heroVideo.currentTime = START; });
      if (heroVideo.readyState >= 1) startAt();
      var hp = heroVideo.play();
      if (hp && hp.then) { hp.then(function () { hero.classList.add('is-playing'); }).catch(function () {}); }
      heroVideo.addEventListener('playing', function () { hero.classList.add('is-playing'); });
    }

    /* ---- hero line-mask reveal (no .reveal wrapper) ---- */
    var heroTitle = root.querySelector('.ap-hero__title');
    if (heroTitle) {
      var revealHero = function () { heroTitle.querySelectorAll('.ap-mask').forEach(function (m) { m.classList.add('is-visible'); }); };
      if (reduce) { revealHero(); }
      else { requestAnimationFrame(function () { setTimeout(revealHero, 120); }); }
    }

    /* ---- INTRO framed video: click-to-play ---- */
    var introTrack = root.querySelector('[data-ap-intro-track]');
    var frame = root.querySelector('[data-ap-frame]');
    var introVideo = root.querySelector('[data-ap-intro-video]');
    var overlay = root.querySelector('[data-ap-overlay]');
    var playBtn = root.querySelector('[data-ap-play]');
    var introTexts = [].slice.call(root.querySelectorAll('[data-ap-intro-text]'));

    if (frame && introVideo) {
      var playFramed = function () {
        if (frame.classList.contains('is-playing')) return;
        frame.classList.add('is-playing');
        introVideo.muted = false; introVideo.controls = true; introVideo.currentTime = 0;
        var pp = introVideo.play();
        if (pp && pp.catch) { pp.catch(function () { introVideo.muted = true; introVideo.play().catch(function () {}); }); }
      };
      frame.addEventListener('click', function () { playFramed(); });
      frame.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); playFramed(); } });
      if (playBtn) { playBtn.addEventListener('click', function (e) { e.stopPropagation(); playFramed(); }); }
    }

    /* ---- PROCESO state ---- */
    var procTrack = root.querySelector('[data-ap-proceso-track]');
    var titles = [].slice.call(root.querySelectorAll('[data-ap-phase-title]'));
    var details = [].slice.call(root.querySelectorAll('[data-ap-phase-detail]'));
    var ticks = [].slice.call(root.querySelectorAll('[data-ap-tick]'));
    var closing = root.querySelector('[data-ap-closing]');
    var N = Math.max(titles.length, details.length) || 6;
    var curPhase = -1;

    function setPhase(idx) {
      if (idx === curPhase) return; curPhase = idx;
      titles.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
      details.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
      ticks.forEach(function (el, i) { el.classList.toggle('on', i === idx); });
    }

    /* ---- reveals (own observer-free loop, mirrors prototype) ---- */
    var revealEls = [].slice.call(root.querySelectorAll('.reveal, .lines'));

    var VH = function () { return window.innerHeight || document.documentElement.clientHeight; };

    function update() {
      var vh = VH();

      // reveals
      for (var i = revealEls.length - 1; i >= 0; i--) {
        var el = revealEls[i]; var r = el.getBoundingClientRect();
        if (r.top < vh * 0.86 && r.bottom > 0) { el.classList.add('is-visible'); revealEls.splice(i, 1); }
      }

      // INTRO: framed video travels to centre growing 40 -> 80vw; text fades; overlay shows
      if (introTrack && frame) {
        if (mobile() || reduce) {
          frame.style.width = ''; frame.style.transform = '';
          introTexts.forEach(function (t) { t.style.opacity = ''; });
        } else {
          var ir = introTrack.getBoundingClientRect();
          var itotal = Math.max(ir.height - vh, 1);
          var prog = clamp01(-ir.top / itotal);
          var e = smoothstep(clamp01(prog / 0.5));
          var w = lerp(40, 80, e);
          var ox = lerp(24, 0, e), oy = lerp(24, 0, e);
          frame.style.width = w + 'vw';
          frame.style.transform = 'translate(calc(-50% + ' + ox + 'vw), calc(-50% + ' + oy + 'vh))';
          var fade = 1 - smoothstep(clamp01((prog - 0.06) / 0.34));
          introTexts.forEach(function (t) { t.style.opacity = fade; });
          if (overlay && !frame.classList.contains('is-playing') && e > 0.92) overlay.classList.add('show');
        }
      }

      // PROCESO: phase + plate scroll-rotation + closing
      if (procTrack) {
        var pr = procTrack.getBoundingClientRect();
        var ptotal = Math.max(pr.height - vh, 1);
        var raw = clamp01(-pr.top / ptotal);
        setPhase(Math.min(N - 1, Math.floor(raw * N * 0.999)));
        if (closing) closing.classList.toggle('is-visible', raw > 0.9);
        if (window.LCPlate) { window.LCPlate.setProgress(raw); }
      }
    }

    setPhase(0);

    var rafAlive = false, failed = false;
    function showStatic() {
      document.documentElement.classList.add('lc-static');
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
    function rafLoop() {
      rafAlive = true;
      // never let a runtime error leave the page stuck on opacity:0 reveals
      try { update(); } catch (err) { if (!failed) { failed = true; showStatic(); } return; }
      requestAnimationFrame(rafLoop);
    }
    requestAnimationFrame(rafLoop);

    // fallback: rAF congelado -> mostrar todo y usar timer
    setTimeout(function () {
      if (rafAlive) return;
      showStatic();
      update(); setInterval(update, 140);
    }, 480);
  }

  document.querySelectorAll('.artesania-page').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.artesania-page').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function init() {
  if (window.__cartDrawerInit) return;

  // Only claim the init flag once the drawer is actually in the DOM. If this
  // script runs before it, retry on DOMContentLoaded — burning the flag on a
  // null lookup left every add-to-cart form falling back to a native POST,
  // i.e. a full page load to /cart instead of opening the drawer.
  var drawer = document.getElementById('cartDrawer');
  if (!drawer) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    return;
  }
  window.__cartDrawerInit = true;

  var body = document.body;
  var bodyEl = drawer.querySelector('[data-cart-body]');
  var emptyEl = drawer.querySelector('[data-cart-empty]');
  var footEl = drawer.querySelector('[data-cart-foot]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var plazoEl = drawer.querySelector('[data-cart-plazo]');
  var noticeEl = drawer.querySelector('[data-cart-notice]');
  var undoEl = drawer.querySelector('[data-cart-undo]');
  var lastRemoved = null;   // { id, quantity } de la última pieza quitada
  var countEls = function () { return document.querySelectorAll('[data-cart-count],[data-cart-count-badge]'); };
  var LB = String.fromCharCode(123), RB = String.fromCharCode(125);
  var moneyFormat = drawer.getAttribute('data-money-format') || ('$' + LB + LB + 'amount' + RB + RB);

  function formatMoney(cents) {
    var value = (cents / 100);
    function withDelimiters(num, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      num = (num || 0).toFixed(precision);
      var parts = num.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? intPart + decimal + parts[1] : intPart;
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelimiters(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(value, 0, ' ', '');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function render(cart) {
    countEls().forEach(function (el) {
      el.textContent = el.hasAttribute('data-cart-count') ? '(' + cart.item_count + ')' : cart.item_count;
      el.toggleAttribute('data-empty', cart.item_count === 0);   // el globo del icono se oculta en 0
    });

    if (!cart.items || cart.items.length === 0) {
      bodyEl.innerHTML = '';
      emptyEl.hidden = false;
      footEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footEl.hidden = false;
    subtotalEl.textContent = formatMoney(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);

    bodyEl.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_160x$1$2') : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<span class="cart-line__variant">' + esc(item.variant_title) + '</span>' : '';
      return '' +
        '<div class="cart-line" data-line-key="' + esc(item.key) + '" data-variant-id="' + esc(item.variant_id) + '" data-qty="' + item.quantity + '">' +
          (img ? '<img class="cart-line__media" src="' + esc(img) + '" alt="" width="72" height="90" loading="lazy">' : '<span class="cart-line__media"></span>') +
          '<div class="cart-line__info">' +
            '<a class="cart-line__title" href="' + esc(item.url) + '">' + esc(item.product_title || item.title) + '</a>' +
            variant +
            '<span class="cart-line__qty">' +
              '<button type="button" data-qty-down aria-label="Restar">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-up aria-label="Sumar">+</button>' +
            '</span>' +
          '</div>' +
          '<div class="cart-line__right">' +
            '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>' +
            '<button type="button" class="cart-line__remove" data-line-remove>Eliminar</button>' +
          '</div>' +
        '</div>';
    }).join('');
    loadPlazos();
  }

  // Plazos calculados en Liquid (templates/cart.plazos.liquid). El del pedido se guarda
  // como atributo «Plazo de entrega» para que llegue al pedido aunque se pague desde aquí.
  function loadPlazos() {
    fetch('/cart?view=plazos', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        Object.keys(p.lineas || {}).forEach(function (key) {
          var info = bodyEl.querySelector('.cart-line[data-line-key="' + key + '"] .cart-line__info');
          if (info && p.lineas[key]) info.querySelector('.cart-line__title').insertAdjacentHTML('afterend', p.lineas[key]);
        });
        plazoEl.textContent = p.pedido || '';
        plazoEl.hidden = !p.pedido;
        if (p.atributo !== p.guardado) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: { 'Plazo de entrega': p.atributo } })
          });
        }
      }).catch(function () {});
  }

  // Shopify responde 422 si se pide más de lo que hay; antes el cajón lo callaba.
  function notice(msg) {
    noticeEl.textContent = msg || '';
    noticeEl.hidden = !msg;
  }
  function json(r) {
    return r.json().then(function (data) {
      if (!r.ok) throw data;
      return data;
    });
  }

  function setLoading(on) { drawer.classList.toggle('is-loading', !!on); }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refresh() {
    return fetchCart().then(render);
  }

  function open() {
    body.classList.add('cart-open');
    drawer.setAttribute('aria-hidden', 'false');
    refresh();
  }
  function close() {
    body.classList.remove('cart-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function change(key, qty, removed) {
    setLoading(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(json).then(function (cart) {
      notice('');
      if (undoEl) undoEl.hidden = !(removed && lastRemoved);
      render(cart);
    }).catch(function (err) {
      notice(err && err.description);
      refresh();
    }).then(function () { setLoading(false); });
  }

  if (undoEl) undoEl.querySelector('[data-cart-undo-button]').addEventListener('click', function () {
    if (!lastRemoved) return;
    var item = lastRemoved; lastRemoved = null; undoEl.hidden = true;
    setLoading(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: item.id, quantity: item.quantity })
    }).then(json).then(function () { return refresh(); })
      .catch(function (err) { notice(err && err.description); })
      .then(function () { setLoading(false); });
  });

  // Delegate clicks inside the drawer.
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    var line = e.target.closest('.cart-line');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qtySpan = line.querySelector('.cart-line__qty span');
    var current = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
    if (e.target.closest('[data-line-remove]')) {
      lastRemoved = { id: line.getAttribute('data-variant-id'), quantity: parseInt(line.getAttribute('data-qty'), 10) || 1 };
      change(key, 0, true);
    }
    else if (e.target.closest('[data-qty-up]')) { change(key, current + 1); }
    else if (e.target.closest('[data-qty-down]')) { change(key, Math.max(0, current - 1)); }
  });

  // Header cart toggle(s).
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) { e.preventDefault(); open(); }
  });

  // Esc closes.
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && body.classList.contains('cart-open')) close();
  });

  // Intercept add-to-cart form submits anywhere on the page.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    var isAdd = action.indexOf('/cart/add') !== -1 || form.querySelector('[name="add"]');
    if (!isAdd) return;
    if (action.indexOf('/cart/add') === -1 && !form.querySelector('[name="id"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"],[name="add"]');
    if (btn) btn.setAttribute('disabled', 'disabled');
    setLoading(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(json).then(function () {
      notice('');
      if (undoEl) undoEl.hidden = true;   // al añadir algo nuevo el «deshacer» ya no aplica
      return refresh();
    }).catch(function (err) {
      notice(err && err.description);
    }).then(function () {
      open();
    }).then(function () {
      if (btn) btn.removeAttribute('disabled');
      setLoading(false);
    });
  });

  // Initial count sync.
  refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
/*
  Único añadido de JS: "Deshacer" tras quitar una pieza. Sin JS el enlace de
  quitar sigue funcionando, sólo que sin deshacer. La pieza retirada viaja en
  sessionStorage porque quitar recarga la página.
*/
(function () {
  var KEY = 'cartuja:cart-undo';

  function store(value) {
    try {
      if (value === null) { sessionStorage.removeItem(KEY); }
      else { sessionStorage.setItem(KEY, JSON.stringify(value)); }
    } catch (e) { /* modo privado: se pierde el deshacer, nada más */ }
  }

  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); }
    catch (e) { return null; }
  }

  function init() {
    var root = document.querySelector('[data-cart-page]');
    if (!root) return;

    // El aviso sólo vale para la retirada que acaba de pasar: se marca con la hora
    // y se borra del almacén nada más leerlo, así que volver a la cesta más tarde
    // (o entrar de nuevas) ya no lo saca sin que nadie haya quitado nada.
    var note = root.querySelector('[data-cart-undo]');
    var pending = read();
    store(null);
    if (pending && pending.at && Date.now() - pending.at > 120000) pending = null;
    if (note && pending && pending.id) note.hidden = false;

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-cart-remove]');
      if (!link) return;
      event.preventDefault();

      var line = link.closest('.cart-page__line');
      if (line) line.classList.add('is-out');

      store({ id: link.dataset.variantId, quantity: parseInt(link.dataset.qty, 10) || 1, at: Date.now() });
      window.location.href = link.href;
    });

    var undo = root.querySelector('[data-cart-undo-button]');
    if (!undo) return;
    undo.addEventListener('click', function () {
      var item = pending;
      if (!item || !item.id) return;
      undo.disabled = true;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.id, quantity: item.quantity })
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        undo.disabled = false;
      });
    });
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"]) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    // Sidebar accordion — one panel open at a time, facets and chapter tree sharing the
    // same rule. The column is sticky and capped to the viewport height, so every extra
    // open panel pushes the ones below out of reach with no page scroll left to recover
    // them; closing the previous panel is what keeps them all reachable.
    var side = root.querySelector('.sidebar');

    function openOnly(section) {
      if (!side) return;
      side.querySelectorAll('.side-section').forEach(function (s) {
        var on = s === section;
        s.classList.toggle('is-open', on);
        var t = s.querySelector('[data-side-toggle]') || s.querySelector('.side-toggle');
        if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    // Server-rendered state can open more than one (an active facet *and* the current
    // chapter), so collapse down to the first before anyone touches it.
    if (side) openOnly(side.querySelector('.side-section.is-open'));

    root.querySelectorAll('.side-toggle, [data-side-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var s = btn.closest('.side-section');
        if (!s) return;
        openOnly(s.classList.contains('is-open') ? null : s); // null closes everything
      });
    });

    // (Product-media hover carousel is handled globally in assets/theme.js.)

    var grid = root.querySelector('#productGrid');

    function placeItems(items) {
      var editorial = grid.querySelector('.editorial-insert');
      var editorialAfter = parseInt(grid.dataset.editorialAfter, 10) || 6;
      items.forEach(function (item) { grid.appendChild(item); });
      if (editorial) grid.insertBefore(editorial, items[editorialAfter] || null);
      var loadMore = grid.querySelector('.load-more');
      if (loadMore) grid.appendChild(loadMore);
    }

    // View toggle
    root.querySelectorAll('.view-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.view-btn').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        if (grid) grid.classList.toggle('is-list', b.dataset.view === 'list');
      });
    });

    // El corazón lo gestiona el handler global de assets/theme.js, que además lo guarda.

    // Budget mode fallback. Normal sort options are real links and Shopify orders the
    // complete collection before pagination. This local sorter only protects the first
    // visit to sets-regalo until its default order is confirmed in the admin.
    function applySort(mode) {
      if (!grid) return;
      var items = [].slice.call(grid.querySelectorAll('.product'));
      items.sort(function (a, c) {
        return mode === 'new' ? (+c.dataset.new - +a.dataset.new)
          : mode === 'high' ? (+c.dataset.price - +a.dataset.price)
          : mode === 'low' ? (+a.dataset.price - +c.dataset.price) : 0;
      });
      placeItems(items);
    }

    var sw = root.querySelector('.sort-wrap');
    if (sw) {
      var sb = sw.querySelector('.sort-btn');
      if (sb) sb.addEventListener('click', function () { sw.classList.toggle('open'); });
    }

    // Resultados intercalados: baraja por tipo para que no salgan las tres palanganas
    // seguidas. Va APAGADO salvo que se marque en los ajustes de la sección, y aun así
    // no se activa si el orden de la colección es «Manual» o si el comprador ha elegido
    // uno: colocar las piezas a mano en el admin es una decisión y manda sobre esto.
    function interleave() {
      if (!grid || !root.dataset.interleave) return;
      if (root.dataset.sortMode === 'manual') return;
      if (location.search.indexOf('sort_by=') > -1) return;
      var items = [].slice.call(grid.querySelectorAll('.product'));
      if (items.length < 6) return;

      var buckets = [];
      var byKey = {};
      items.forEach(function (el) {
        var key = el.dataset.type || '';
        if (!byKey[key]) { byKey[key] = []; buckets.push(byKey[key]); }
        byKey[key].push(el);
      });
      if (buckets.length < 2) return;

      var mixed = [];
      for (var round = 0; mixed.length < items.length; round++) {
        buckets.forEach(function (b) { if (b[round]) mixed.push(b[round]); });
      }

      placeItems(mixed);
    }

    // Budget mode ("Sets para regalo"): price ascending without touching the sort menu.
    // ponytail: this only reorders what is already in the DOM — the collection's own
    // "Price: low to high" order in the admin is what sorts the whole collection across
    // pages. This is the backup for when that admin setting drifts.
    var defaultSort = root.dataset.defaultSort;
    if (defaultSort) applySort(defaultSort); else interleave();

    // Facets — progressive enhancement only. The <form method="get"> in
    // snippets/collection-filters.liquid already filters on its own (Shopify does the
    // work server-side), so everything here is about not reloading the page.
    //
    // The swap replaces the whole section root rather than patching pieces of it: the
    // fetched node carries no stale listeners and init() re-runs on it from scratch, so
    // the accordion, sort, load-more and budget mode all come back wired without a
    // second code path. Any failure falls through to a real navigation.
    var form = root.querySelector('[data-filters]');
    if (form) {
      document.documentElement.classList.add('js-facets');
      var busy = false;

      function facetUrl() {
        // An empty price box must not travel: `filter.v.price.gte=` pins the range to 0
        // and returns nothing.
        var qs = new URLSearchParams();
        new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') qs.append(k, v); });
        var q = qs.toString();
        return location.pathname + (q ? '?' + q : '');
      }

      // Dos puertas al mismo cajón: «Filtrar» en la barra (móvil) y «+ Filtros» en
      // el lateral (escritorio). Ambas llevan data-filters-open, así que el aria hay
      // que devolverlo en las dos.
      function closeDrawer() {
        root.classList.remove('filters-drawer-open');
        root.querySelectorAll('[data-filters-open]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
        });
        document.body.style.overflow = '';
      }

      function go(url) {
        if (busy) return;
        busy = true;
        root.classList.add('is-filtering');
        // El cajón sobrevive al re-render: el nodo se sustituye entero, así que su
        // estado abierto hay que volver a ponerlo o cada clic lo cerraría de golpe.
        var wasOpen = root.classList.contains('filters-drawer-open');
        var sid = root.dataset.sectionId;
        fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid))
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var next = new DOMParser().parseFromString(html, 'text/html').querySelector('.collection-grid');
            if (!next) return Promise.reject('no section');
            history.replaceState({}, '', url);
            root.replaceWith(next);
            if (wasOpen) {
              next.classList.add('filters-drawer-open');
              var opener = next.querySelector('[data-filters-open]');
              if (opener) opener.setAttribute('aria-expanded', 'true');
            } else {
              document.body.style.overflow = '';
            }
            init(next);
            // ponytail: same trick as load-more — let theme.js rewire the reveal observer.
            next.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
          })
          .catch(function () { location.assign(url); })
          .then(function () { busy = false; });
      }

      // También en el cajón: el pie dice "Mostrar resultados (246)" y ese número tiene
      // que ser el de verdad, así que cada marca se aplica y vuelve con el recuento nuevo.
      form.addEventListener('change', function () { go(facetUrl()); });
      form.addEventListener('submit', function (e) { e.preventDefault(); go(facetUrl()); });

      // Chips, "clear" and the sidebar's clear link are ordinary <a href> — intercept
      // them so they take the same in-place path instead of a full reload.
      root.addEventListener('click', function (e) {
        var a = e.target.closest('.facet-chip, .facet-chips-clear, [data-filters-clear], [data-facet-link]');
        if (a && a.getAttribute('href')) { e.preventDefault(); go(a.getAttribute('href')); return; }

        if (e.target.closest('[data-filters-open]')) {
          root.classList.add('filters-drawer-open');
          root.querySelectorAll('[data-filters-open]').forEach(function (t) {
            t.setAttribute('aria-expanded', 'true');
          });
          document.body.style.overflow = 'hidden';
          return;
        }
        if (e.target.closest('[data-filters-close]')) { closeDrawer(); return; }
        // Tap on the scrim (the ::after covers the page, so the hit lands on root itself).
        if (e.target === root && root.classList.contains('filters-drawer-open')) closeDrawer();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('filters-drawer-open')) closeDrawer();
      });

      // Doble slider de precio. Sólo escribe en los dos inputs numéricos, que son los
      // que llevan `name`; al soltar dispara el mismo `change` que cualquier faceta.
      var range = root.querySelector('[data-price-range]');
      if (range) {
        var low = range.querySelector('[data-range-low]');
        var high = range.querySelector('[data-range-high]');
        var fill = range.querySelector('[data-range-fill]');
        var numMin = root.querySelector('[data-price-min]');
        var numMax = root.querySelector('[data-price-max]');
        var cap = parseInt(range.dataset.cap, 10) || 0;
        range.hidden = false;

        function paint() {
          if (!cap) return;
          fill.style.left = (low.value / cap * 100) + '%';
          fill.style.width = ((high.value - low.value) / cap * 100) + '%';
        }

        function pull(fromSlider) {
          var a = parseInt(low.value, 10);
          var b = parseInt(high.value, 10);
          if (a > b) { if (fromSlider === low) { a = b; low.value = b; } else { b = a; high.value = a; } }
          // Un extremo pegado al tope no es un filtro: se deja vacío para no mandarlo.
          numMin.value = a > 0 ? a : '';
          numMax.value = b < cap ? b : '';
          paint();
        }

        [low, high].forEach(function (el) {
          el.addEventListener('input', function () { pull(el); });
          el.addEventListener('change', function () {
            pull(el);
            numMax.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });

        // Teclear en los números mueve los tiradores.
        [numMin, numMax].forEach(function (el, i) {
          el.addEventListener('input', function () {
            var v = parseInt(el.value, 10);
            if (isNaN(v)) v = i === 0 ? 0 : cap;
            (i === 0 ? low : high).value = Math.min(Math.max(v, 0), cap);
            paint();
          });
        });

        paint();
      }
    }

    // Load more (demo reveal)
    var lm = root.querySelector('#loadMore');
    if (lm) lm.addEventListener('click', function () {
      root.querySelectorAll('.extra-product.is-hidden').forEach(function (el) { el.classList.remove('is-hidden'); el.classList.add('is-visible'); });
      lm.style.display = 'none';
    });

    // Load more (real path) — append the next paginated page instead of navigating to it,
    // and auto-fire when the block scrolls into view. The <a href> stays a real link, so
    // no-JS and crawlers keep the normal ?page=N flow.
    var more = root.querySelector('.load-more[data-total]');
    var link = more && more.querySelector('a[rel="next"]');
    if (grid && link) {
      var count = more.querySelector('.load-count');
      var observer = null;
      var loading = false;

      function done() {
        if (observer) { observer.disconnect(); observer = null; }
        link.remove();
        link = null;
      }

      function loadNext() {
        if (loading || !link) return;
        loading = true;
        more.classList.add('is-loading');
        // Section Rendering API: returns just this section, not the whole document.
        var sid = root.dataset.sectionId;
        fetch(link.href + (sid ? '&section_id=' + encodeURIComponent(sid) : ''))
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var next = new DOMParser().parseFromString(html, 'text/html').querySelector('#productGrid');
            if (!next) return done();
            // Only .product nodes: the next page renders its own .editorial-insert, which
            // must not be duplicated mid-grid.
            next.querySelectorAll('.product').forEach(function (el) { grid.insertBefore(el, more); });
            if (defaultSort) applySort(defaultSort); else interleave(); // mantiene el criterio al paginar
            var nextCount = next.querySelector('.load-count');
            if (count && nextCount) count.textContent = nextCount.textContent;
            var nextLink = next.querySelector('.load-more a[rel="next"]');
            if (nextLink) link.href = nextLink.href; else done();
            // ponytail: let theme.js's shopify:section:load handler pick up the new cards
            // (reveal observer) instead of re-implementing it here. init() is guarded by
            // root.dataset.init, so the section's own listener re-entry is a no-op.
            root.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
          })
          .catch(function () { if (link) link.removeAttribute('data-ajax'); }) // fall back to plain navigation
          .then(function () { loading = false; more.classList.remove('is-loading'); });
      }

      link.dataset.ajax = '1';
      link.addEventListener('click', function (e) {
        if (!link.dataset.ajax) return; // a failed fetch reverts to normal navigation
        e.preventDefault();
        loadNext();
      });

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) loadNext();
        }, { rootMargin: '600px' });
        observer.observe(more);
      }
    }
  }

  document.querySelectorAll('.collection-grid').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.collection-grid').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';
    var strip = root.querySelector('[data-collections-strip]');
    var prev = root.querySelector('.landing-prev');
    var next = root.querySelector('.landing-next');
    if (!strip || !prev || !next) return;
    var x = 0;
    var max = function () { return Math.max(0, strip.scrollWidth - window.innerWidth + window.innerWidth * 0.05); };
    var cardStep = function () { var c = strip.querySelector('.landing-card'); return c ? c.getBoundingClientRect().width + 34 : 360; };
    var update = function () {
      x = Math.max(0, Math.min(x, max()));
      strip.style.transform = 'translate3d(' + (-x) + 'px,0,0)';
      prev.disabled = x <= 2;
      next.disabled = x >= max() - 2;
    };
    prev.addEventListener('click', function () { x -= cardStep(); update(); });
    next.addEventListener('click', function () { x += cardStep(); update(); });
    var stage = root.querySelector('.collections-stage-v26');
    if (stage) {
      var inView = function () {
        var r = stage.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      };
      stage.addEventListener('wheel', function (e) {
        if (!inView()) return;
        var m = max();
        if (m <= 0) return;
        var delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
        var nextX = x + delta * 1.15;
        if ((nextX >= 0 && nextX <= m) || (x > 0 && x < m)) {
          e.preventDefault();
          x = nextX;
          update();
        }
      }, { passive: false });
    }
    window.addEventListener('resize', update);
    update();
  }
  document.querySelectorAll('.collections-landing').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.collections-landing').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.editorial-collections:not([data-init])').forEach(init);

  function init(root) {
    root.dataset.init = '1';
    const track = root.querySelector('[data-ec-track]');
    if (!track) return;

    // En escritorio el track es una rejilla sin overflow, así que scrollBy no hace
    // nada y las flechas están ocultas: no hace falta comprobar el breakpoint.
    function step(dir) {
      const card = track.querySelector('.editorial-collections__item');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
    }

    root.querySelector('[data-ec-prev]')?.addEventListener('click', () => step(-1));
    root.querySelector('[data-ec-next]')?.addEventListener('click', () => step(1));
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.editorial-collections:not([data-init])').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.editorial-hero:not([data-init])');
  sections.forEach(initHero);

  function initHero(root) {
    root.dataset.init = '1';
    const isMobile = window.matchMedia('(max-width: 680px)').matches;
    if (isMobile) return; // mobile uses static hero, no scroll math

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    function update() {
      const rect = root.getBoundingClientRect();
      const max = Math.max(root.offsetHeight - window.innerHeight, 1);
      const raw = clamp(-rect.top / max, 0, 1);
      const dim = clamp((raw - 0.06) / 0.34, 0, 0.58);
      const titleOpacity = clamp((raw - 0.16) / 0.20, 0, 1);
      const holdProgress = clamp(raw / 0.82, 0, 1);
      const styles = document.documentElement.style;
      styles.setProperty('--hero-progress', holdProgress.toFixed(3));
      styles.setProperty('--hero-dim', dim.toFixed(3));
      styles.setProperty('--hero-title-opacity', titleOpacity.toFixed(3));
      styles.setProperty('--hero-clip-left', '0%');
      styles.setProperty('--hero-clip-right', '100%');
      styles.setProperty('--hero-clip-top', '0%');
      styles.setProperty('--hero-clip-bottom', '100%');
      styles.setProperty('--hero-media-scale', (1.04 - (raw * 0.02)).toFixed(3));
    }

    let ticking = false;
    function tick() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { update(); ticking = false; });
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    update();
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.editorial-hero:not([data-init])').forEach(initHero);
  });

  // Tramos del vídeo con fondo blanco: el hero deja de pedir cabecera clara y pasa a
  // tinta oscura (título, botón, progreso) para que nada blanco quede sobre blanco.
  function initInk(hero) {
    const video = hero.querySelector('video');
    const spans = (hero.dataset.lightFrames || '').split(',').map((s) => s.split('-').map(Number))
      .filter((s) => s.length === 2 && s.every((n) => !isNaN(n)));
    if (!video || !spans.length) return;
    let light = false;
    video.addEventListener('timeupdate', () => {
      const t = video.currentTime;
      const now = spans.some(([a, b]) => t >= a && t < b);
      if (now === light) return;
      light = now;
      hero.classList.toggle('is-light-frame', light);
      if (light) hero.removeAttribute('data-header-variant');
      else hero.setAttribute('data-header-variant', 'light');
      window.dispatchEvent(new Event('scroll')); // la cabecera recalcula su tinta
    });
  }
  document.querySelectorAll('.editorial-hero[data-light-frames]').forEach(initInk);

  // Sonido del vídeo: el botón lo activa y sólo suena con el hero en pantalla.
  // Al bajar de la sección el vídeo se pausa (y calla); al volver sigue, y con
  // sonido si el visitante lo había activado. Fundidos para que no entre de golpe.
  function initSound(btn) {
    if (btn.dataset.init) return;
    btn.dataset.init = '1';
    const hero = btn.closest('.editorial-hero');
    const video = hero && hero.querySelector('video');
    if (!video) return;
    let wanted = false; // lo que eligió el visitante
    let inView = true;
    let fade;
    // ponytail: en iOS `volume` es de sólo lectura; allí el fundido no hace nada y manda `muted`.
    function ramp(to, done) {
      clearInterval(fade);
      fade = setInterval(() => {
        const before = video.volume;
        const next = before + (to > before ? 0.05 : -0.05);
        video.volume = Math.min(1, Math.max(0, next));
        // iOS ignora `volume` (sigue en 1): sin esta salida el fundido no acababa
        // nunca y el vídeo no llegaba a `muted` — el botón no silenciaba en móvil.
        if (video.volume === before || Math.abs(video.volume - to) < 0.051) {
          clearInterval(fade);
          if (video.volume !== before) video.volume = to;
          if (done) done();
        }
      }, 40);
    }
    function apply() {
      const on = wanted && inView && !document.hidden;
      if (on) {
        video.muted = false;
        ramp(1);
      } else if (!video.muted) {
        ramp(0, () => { video.muted = true; });
      }
      if (inView && !document.hidden) video.play().catch(() => {});
      else video.pause();
    }
    btn.addEventListener('click', () => {
      wanted = !wanted;
      btn.setAttribute('aria-pressed', wanted ? 'true' : 'false');
      btn.setAttribute('aria-label', wanted ? btn.dataset.labelPause : btn.dataset.labelPlay);
      if (wanted) { video.volume = 0; video.muted = false; }
      // 2026-10-05 · cliente: en móvil pulsar no silenciaba. El silencio va síncrono dentro
      // del toque, sin depender del fundido (que en iOS no hace nada con `volume`).
      else { clearInterval(fade); video.muted = true; }
      apply();
    });
    new IntersectionObserver((entries) => {
      inView = entries[entries.length - 1].isIntersecting;
      apply();
    }).observe(hero);
    document.addEventListener('visibilitychange', apply);
  }
  document.querySelectorAll('[data-hero-sound]').forEach(initSound);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-hero-sound]').forEach(initSound));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["favorites"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'cartuja:favs';
  function read() { try { var l = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
  function write(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }

  function init(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';
    var grid = root.querySelector('[data-favorites-grid]');
    var empty = root.querySelector('[data-favorites-empty]');
    function toggleEmpty() { empty.hidden = grid.children.length > 0; }

    var favs = read().filter(function (u) { return /^\/products\//.test(u); });
    if (!favs.length) { toggleEmpty(); return; }

    Promise.all(favs.map(function (url) {
      return fetch(url.split('?')[0] + '?section_id=fav-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      var alive = [];
      htmls.forEach(function (html, i) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var card = tmp.querySelector('.product');
        if (!card) return; // producto borrado o sin publicar: se cae de la lista
        card.classList.add('is-visible');
        grid.appendChild(card);
        alive.push(favs[i]);
      });
      if (alive.length !== favs.length) write(alive);
      toggleEmpty();
      grid.querySelectorAll('.fav').forEach(function (b) { b.classList.add('active'); b.setAttribute('aria-pressed', 'true'); });
    });

    // Quitar el corazón aquí saca la pieza de la página (theme.js ya la quitó de la lista).
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.fav');
      if (!btn) return;
      setTimeout(function () {
        if (read().indexOf(btn.dataset.favKey) === -1) { btn.closest('.product').remove(); toggleEmpty(); }
      }, 0);
    });
  }

  document.querySelectorAll('[data-favorites]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-favorites]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.currentScript.previousElementSibling?.closest('.featured-products') || document.querySelector('.featured-products:not([data-init])');
  document.querySelectorAll('.featured-products:not([data-init])').forEach(initCarousel);

  function initCarousel(root) {
    root.dataset.init = '1';
    const track = root.querySelector('[data-carousel-track]');
    const viewport = track && track.parentElement;
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track || !viewport) return;

    const cardW = () => {
      const c = track.firstElementChild;
      return c ? c.getBoundingClientRect().width : viewport.clientWidth;
    };

    // Infinite loop: clone the set before + after, scroll lives in the middle copy.
    // ponytail: desktop carousel only — mobile is a static grid, so we skip cloning
    // (it would duplicate the grid). No re-clone on breakpoint resize.
    let loop = false, setW = 0;
    if (window.matchMedia('(min-width: 681px)').matches && track.children.length > 1) {
      const originals = [...track.children];
      originals.forEach(c => { const cl = c.cloneNode(true); cl.setAttribute('aria-hidden', 'true'); track.appendChild(cl); });
      for (let i = originals.length - 1; i >= 0; i--) { const cl = originals[i].cloneNode(true); cl.setAttribute('aria-hidden', 'true'); track.insertBefore(cl, track.firstChild); }
      requestAnimationFrame(() => {
        setW = originals.reduce((s, c) => s + c.getBoundingClientRect().width, 0);
        if (setW > viewport.clientWidth) { loop = true; viewport.scrollLeft = setW; }
        // Con tantas tarjetas como columnas (3 fichas a 3 por fila) el set no desborda:
        // no hay bucle que corregir y los clones se quedarían a la vista al arrastrar.
        else [...track.children].forEach(c => { if (c.getAttribute('aria-hidden') === 'true') c.remove(); });
      });
      viewport.addEventListener('scroll', () => {
        if (!loop) return;
        if (viewport.scrollLeft >= setW * 2) viewport.scrollLeft -= setW;
        else if (viewport.scrollLeft < setW) viewport.scrollLeft += setW;
      });
    }

    // Arrows nudge one card; native smooth scroll handles the glide.
    prev && prev.addEventListener('click', () => viewport.scrollBy({ left: -cardW(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => viewport.scrollBy({ left: cardW(), behavior: 'smooth' }));

    // Mouse drag with kinetic inertia (free glide, no snap). Touch uses native momentum.
    let down = false, startX = 0, startLeft = 0, moved = false, lastX = 0, lastT = 0, vx = 0, raf = 0;
    const maxLeft = () => viewport.scrollWidth - viewport.clientWidth;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;            // native touch scroll
      if (e.button !== 0) return;
      cancelAnimationFrame(raf);
      down = true; moved = false; startX = lastX = e.clientX; startLeft = viewport.scrollLeft;
      vx = 0; lastT = performance.now();
    });
    track.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 5 && !moved) {
        // Real drag started — capture now (NOT on pointerdown, or a plain
        // click would target the track instead of the card's <a> and never navigate).
        moved = true;
        track.setPointerCapture?.(e.pointerId);
        track.classList.add('is-dragging');
      }
      viewport.scrollLeft = startLeft - dx;
      const now = performance.now(), dt = now - lastT || 16;
      vx = (e.clientX - lastX) / dt;                    // px per ms (signed)
      lastX = e.clientX; lastT = now;
    });
    const end = (e) => {
      if (!down) return;
      down = false;
      track.releasePointerCapture?.(e.pointerId);
      track.classList.remove('is-dragging');
      let v = -vx * 16;                                 // px per frame, continues the flick
      const glide = () => {
        v *= 0.94;                                      // friction
        viewport.scrollLeft += v;
        const at = viewport.scrollLeft;
        if (Math.abs(v) > 0.4 && at > 0 && at < maxLeft()) raf = requestAnimationFrame(glide);
      };
      if (moved && Math.abs(v) > 0.4) raf = requestAnimationFrame(glide);
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    // Block native image/link drag so a press-drag scrolls instead of ghost-dragging an image.
    track.addEventListener('dragstart', (e) => e.preventDefault());
    // Swallow only the click that ends a real drag; `moved` resets on every pointerdown.
    track.addEventListener('click', (e) => {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.featured-products:not([data-init])').forEach(initCarousel);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  const header = document.getElementById('siteHeader');
  const menuToggle = document.getElementById('menuToggle');
  const body = document.body;

  const drawer = document.getElementById('mobileDrawer');
  const compact = window.matchMedia('(max-width: 1050px)');

  // Cajón móvil: vistas apiladas (principal → entrada), acordeones y bloqueo de scroll.
  const drawerViews = drawer ? Array.from(drawer.querySelectorAll('[data-mobile-view]')) : [];
  const drawerTitle = drawer && drawer.querySelector('[data-drawer-title]');
  const drawerBack = drawer && drawer.querySelector('[data-drawer-back]');
  const setDrawerView = (name) => {
    const view = drawerViews.find((v) => v.dataset.mobileView === name);
    if (!view) return;
    drawerViews.forEach((v) => v.classList.toggle('is-active', v === view));
    drawerTitle.textContent = name === 'main' ? drawerTitle.dataset.rootTitle : view.dataset.title;
    drawerBack.hidden = name === 'main';
    view.scrollTop = 0;
  };
  const openDrawer = () => {
    setDrawerView('main');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    body.classList.add('menu-lock');
  };
  const closeDrawer = () => {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
    body.classList.remove('menu-lock');
  };
  const closeMega = () => {
    body.classList.remove('menu-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  };

  if (menuToggle) {
    menuToggle.addEventListener('click', () => {
      if (drawer && compact.matches) {
        drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
        return;
      }
      const open = body.classList.toggle('menu-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  if (drawer) {
    drawer.querySelectorAll('[data-mobile-open]').forEach((btn) => btn.addEventListener('click', () => setDrawerView(btn.dataset.mobileOpen)));
    drawer.querySelectorAll('.accordion-toggle').forEach((btn) => btn.addEventListener('click', () => {
      const open = btn.closest('.mobile-accordion').classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }));
    drawer.querySelector('[data-drawer-close]').addEventListener('click', closeDrawer);
    drawerBack.addEventListener('click', () => setDrawerView('main'));
    compact.addEventListener('change', () => { closeDrawer(); closeMega(); });
  }

  const searchToggle = document.getElementById('searchToggle');
  const searchPanel = document.getElementById('searchPanel');
  // Dos botones: el de la derecha (escritorio) y el de la izquierda (móvil).
  const searchToggles = [searchToggle, ...document.querySelectorAll('[data-search-toggle]')].filter(Boolean);
  const closeSearch = () => {
    body.classList.remove('search-open');
    searchToggles.forEach((t) => t.setAttribute('aria-expanded', 'false'));
  };
  if (searchToggle && searchPanel) {
    const input = searchPanel.querySelector('input');
    const results = searchPanel.querySelector('#searchResults');
    const predictiveUrl = searchPanel.dataset.predictiveUrl || '/search/suggest';
    let timer;
    let lastTerm = '';

    const renderResults = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('.shopify-section') || doc.body;
      results.innerHTML = section ? section.innerHTML : '';
    };

    const fetchResults = (term) => {
      const url = predictiveUrl
        + '?q=' + encodeURIComponent(term)
        + '&section_id=predictive-search'
        + '&resources[type]=product&resources[limit]=6';
      fetch(url)
        .then((r) => (r.ok ? r.text() : ''))
        .then(renderResults)
        .catch(() => { results.innerHTML = ''; });
    };

    input.addEventListener('input', () => {
      const term = input.value.trim();
      if (term === lastTerm) return;
      lastTerm = term;
      clearTimeout(timer);
      if (term.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(() => fetchResults(term), 220);
    });

    const searchClose = searchPanel.querySelector('[data-search-close]');
    if (searchClose) searchClose.addEventListener('click', () => {
      if (input) input.value = '';
      if (results) results.innerHTML = '';
      closeSearch();
    });

    searchToggles.forEach((toggle) => toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = body.classList.toggle('search-open');
      searchToggles.forEach((t) => t.setAttribute('aria-expanded', open ? 'true' : 'false'));
      if (open) {
        body.classList.remove('menu-open');
        if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
        setTimeout(() => input && input.focus(), 60);
      }
    }));
    document.addEventListener('click', (e) => {
      if (body.classList.contains('search-open') && !searchPanel.contains(e.target) && !searchToggles.some((t) => t.contains(e.target))) {
        closeSearch();
      }
    });
  }

  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (body.classList.contains('menu-open')) closeMega();
    closeDrawer();
    if (body.classList.contains('search-open')) closeSearch();
  });

  const mobileQuery = window.matchMedia('(max-width: 780px)');
  function updateHeaderState() {
    const scrollY = window.scrollY;
    const scrolled = scrollY > 40;

    const probeY = (header.offsetHeight || 80) / 2;
    let lightVariant = false;
    document.querySelectorAll('[data-header-variant="light"]').forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top <= probeY && rect.bottom >= probeY) lightVariant = true;
    });

    header.classList.toggle('light', lightVariant);
    /* v101: en móvil el hero hace scroll normal por debajo de la barra: sin fondo,
       su texto y el botón de sonido se montaban sobre menú y logo. En escritorio el
       hero es sticky y la barra sigue transparente. */
    header.classList.toggle('scrolled', scrolled && (!lightVariant || mobileQuery.matches));
  }

  window.addEventListener('scroll', updateHeaderState, { passive: true });
  window.addEventListener('resize', updateHeaderState);
  document.addEventListener('shopify:section:load', updateHeaderState);
  updateHeaderState();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-bubble"]) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var fab = root.querySelector('[data-help-toggle]');
    var panel = root.querySelector('#helpPanel');
    var closeBtn = root.querySelector('[data-help-close]');
    var box = root.querySelector('[data-help-message]');
    var send = root.querySelector('[data-help-send]');
    if (!fab || !panel) return;

    // ── Open / closed ────────────────────────────────────────────────────────
    // The shop's hours are Madrid time; the visitor's clock is not. Reading "now"
    // through the shop timezone is the only way a shopper in another country gets
    // told the truth. Any failure leaves the dot grey and the greeting untouched —
    // never a wrong "we're open".
    function shopNow(tz) {
      // 'sv-SE' da "2026-09-08 18:23:38"; con la T es ISO y lo parsea cualquier
      // navegador. El formato 'en-US' ("9/8/2026, 6:23:38 PM") lo rechaza Safari:
      // devolvía Invalid Date, que es truthy, y la tienda salía siempre cerrada.
      try {
        var d = new Date(new Date().toLocaleString('sv-SE', { timeZone: tz }).replace(' ', 'T'));
        return isNaN(d.getTime()) ? null : d;
      } catch (e) { return null; }
    }

    function toMinutes(hhmm) {
      var p = String(hhmm || '').split(':');
      var h = parseInt(p[0], 10), m = parseInt(p[1], 10) || 0;
      return isNaN(h) ? null : h * 60 + m;
    }

    function isOpen() {
      var now = shopNow(root.dataset.tz);
      var from = toMinutes(root.dataset.open);
      var to = toMinutes(root.dataset.close);
      if (!now || from === null || to === null) return null;
      var days = (root.dataset.days || '').split(',').map(function (d) { return parseInt(d, 10); });
      if (days.indexOf(now.getDay()) === -1) return false;
      var mins = now.getHours() * 60 + now.getMinutes();
      return mins >= from && mins < to;
    }

    var open = isOpen();
    var dot = root.querySelector('[data-help-dot]');
    if (dot && open === true) dot.classList.add('is-live');
    if (open === false) {
      var greeting = root.querySelector('[data-help-greeting]');
      var closedText = root.dataset.greetingClosed;
      if (greeting && closedText) greeting.textContent = closedText;
    }

    // ── Panel ────────────────────────────────────────────────────────────────
    // Móvil: el panel ocupa la pantalla, pero en iOS el teclado no encoge `100dvh`;
    // la página sube y la cabecera con la X se salía por arriba. Mientras está
    // abierto, el panel se ciñe al área visible (visualViewport).
    var mobile = window.matchMedia('(max-width: 620px)');
    var vv = window.visualViewport;
    function fit() {
      if (!vv || panel.hidden || !mobile.matches) { panel.style.height = ''; panel.style.top = ''; return; }
      panel.style.height = vv.height + 'px';
      panel.style.top = vv.offsetTop + 'px';
    }
    if (vv) { vv.addEventListener('resize', fit); vv.addEventListener('scroll', fit); }

    function setOpen(on) {
      root.classList.toggle('is-open', on);
      if (!on) root.classList.remove('is-typing'); // no en blur: al reaparecer el saludo, «Enviar» se movía bajo el dedo
      panel.hidden = !on;
      fab.setAttribute('aria-expanded', on ? 'true' : 'false');
      fit();
      // En táctil no se enfoca el mensaje al abrir: sacaría el teclado de golpe.
      if (on && box && !window.matchMedia('(pointer: coarse)').matches) box.focus();
      if (on && closeBtn && window.matchMedia('(pointer: coarse)').matches) closeBtn.focus({ preventScroll: true });
      if (!on) fab.focus();
    }

    if (box) {
      box.addEventListener('focus', function () { root.classList.add('is-typing'); fit(); });
    }

    fab.addEventListener('click', function () { setOpen(panel.hidden); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) setOpen(false);
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !root.contains(e.target)) setOpen(false);
    });

    // ── Send ─────────────────────────────────────────────────────────────────
    // The href is already a working wa.me link; this only prefills what was typed.
    if (send && box) {
      send.addEventListener('click', function () {
        var text = box.value.trim();
        send.href = 'https://wa.me/' + send.dataset.wa + (text ? '?text=' + encodeURIComponent(text) : '');
      });
    }
  }

  document.querySelectorAll('[data-help]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-help]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-doc"]) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root) return;
    const progress = root.querySelector('.legal-progress');
    const sections = [...root.querySelectorAll('.legal-section[id]')];
    const links = [...root.querySelectorAll('.legal-index a')];
    if (!progress && !sections.length) return;

    const update = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (progress) progress.style.width = `${max > 0 ? (window.scrollY / max) * 100 : 0}%`;
      let active = sections.length ? sections[0].id : null;
      for (const section of sections) {
        if (section.getBoundingClientRect().top <= 230) active = section.id;
      }
      links.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${active}`));
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  document.querySelectorAll('.legal-page').forEach(init);
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.legal-page')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-tables"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initScene(scene) {
    var slot = scene.querySelector('.table-product-slot');
    if (!slot) return;
    var items = [].slice.call(slot.querySelectorAll('.table-product-item'));
    if (!items.length) return;
    var hotspots = [].slice.call(scene.querySelectorAll('[data-table-hotspot]'));
    var current = 0;

    /* Las coordenadas de un hotspot son % de la FOTO, no de la caja: la foto va en
       object-fit: cover y la caja cambia de proporción por breakpoint, así que se
       recalcula el recorte y se coloca el punto en px. El % inline queda de respaldo. */
    var photo = scene.querySelector('.table-scene-photo');
    var img = photo && photo.querySelector('img');
    function placeHotspots() {
      if (!img || !img.naturalWidth || !hotspots.length) return;
      var bw = photo.clientWidth, bh = photo.clientHeight;
      var k = Math.max(bw / img.naturalWidth, bh / img.naturalHeight);
      var w = img.naturalWidth * k, h = img.naturalHeight * k;
      var ox = (bw - w) / 2, oy = (bh - h) / 2;
      /* El recorte puede dejar una pieza fuera: el punto se queda pegado al borde. */
      var m = 16;
      hotspots.forEach(function (hs) {
        var x = ox + w * (parseFloat(hs.dataset.x) || 0) / 100;
        var y = oy + h * (parseFloat(hs.dataset.y) || 0) / 100;
        hs.style.left = Math.min(Math.max(x, m), bw - m) + 'px';
        hs.style.top = Math.min(Math.max(y, m), bh - m) + 'px';
      });
    }
    if (img) {
      if (img.complete) placeHotspots(); else img.addEventListener('load', placeHotspots);
      window.addEventListener('resize', placeHotspots);
    }

    function apply() {
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === current); });
      hotspots.forEach(function (h, i) { h.classList.toggle('active', i === current); });
    }
    function show(i) {
      current = ((i % items.length) + items.length) % items.length;
      if (reduce.matches) { apply(); return; }
      slot.classList.add('is-changing');
      setTimeout(function () { apply(); slot.classList.remove('is-changing'); }, 120);
    }

    var prev = scene.querySelector('[data-table-prev]');
    var next = scene.querySelector('[data-table-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    hotspots.forEach(function (h) {
      h.addEventListener('click', function () { show(Number(h.dataset.tableHotspot || 0)); });
    });
    slot.addEventListener('click', function (e) {
      var go = e.target.closest('[data-go]');
      if (go) show(Number(go.dataset.go));
    });

    /* Arrastrar entre piezas, con dedo y con ratón. Pointer Events cubren los dos;
       `touch-action: pan-y` en el slot deja el scroll vertical al navegador y nos
       reserva el horizontal. Los items van apilados (sólo uno visible), así que es
       un gesto por umbral —45 px— y no un carril que sigue al puntero.
       ponytail: si hace falta que la imagen siga al puntero, hay que pasar los
       items a un track con transform, como el carrusel de la home. */
    if (items.length > 1 && window.PointerEvent) {
      var startX = 0, startY = 0, tracking = false, dragged = false;

      /* Sin esto, arrastrar sobre la foto arranca el drag nativo de la imagen. */
      slot.addEventListener('dragstart', function (e) { e.preventDefault(); });

      slot.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        startX = e.clientX; startY = e.clientY;
        tracking = true; dragged = false;
      });

      slot.addEventListener('pointermove', function (e) {
        if (!tracking) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        /* Gesto más vertical que horizontal: es scroll, no cambio de pieza. */
        if (!dragged && Math.abs(dy) > Math.abs(dx)) { tracking = false; return; }
        if (!dragged && Math.abs(dx) > 8) {
          dragged = true;
          /* Capturar el puntero sólo al empezar el arrastre: capturarlo en pointerdown
             manda el clic del ratón al slot y los botones «Añadir» no envían su form. */
          if (slot.setPointerCapture) { try { slot.setPointerCapture(e.pointerId); } catch (err) {} }
        }
      });

      slot.addEventListener('pointerup', function (e) {
        if (!tracking) return;
        tracking = false;
        var dx = e.clientX - startX;
        if (Math.abs(dx) < 45) return;
        show(dx < 0 ? current + 1 : current - 1);
      });

      slot.addEventListener('pointercancel', function () { tracking = false; });

      /* Un arrastre no debe abrir la ficha ni saltar de punto. En captura para
         llegar antes que el handler de [data-go] y que el enlace de la imagen. */
      slot.addEventListener('click', function (e) {
        if (!dragged) return;
        dragged = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }
  }

  function init(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var filters = [].slice.call(root.querySelectorAll('[data-table-filter]'));
    var blocks = [].slice.call(root.querySelectorAll('[data-table-type]'));
    filters.forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.classList.contains('active') ? 'true' : 'false');
      btn.addEventListener('click', function () {
        var type = btn.dataset.tableFilter || 'all';
        filters.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        blocks.forEach(function (block) {
          var show = type === 'all' || block.dataset.tableType === type;
          block.classList.toggle('is-hidden', !show);
          block.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
        /* v99: en móvil los filtros van en una tira scrollable — centra el pulsado. */
        if (window.innerWidth <= 760) {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }, { passive: true });
    });

    root.querySelectorAll('.table-shop-scene').forEach(initScene);
  }

  document.querySelectorAll('.tables-page').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.tables-page').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"]) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    // Desplegable de opciones (letra del mug): cambiar = ir a esa variante.
    root.querySelectorAll('[data-option-select] select').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.value) window.location.href = select.form.action + '?variant=' + select.value;
      });
    });

    // Gallery carousel
    var gallery = root.querySelector('[data-product-gallery] .product-main-media');
    if (gallery) {
      var slides = [].slice.call(gallery.querySelectorAll('.product-gallery-slide'));
      var lines = [].slice.call(gallery.querySelectorAll('.product-gallery-lines span'));
      var index = 0;
      // back = la nueva foto entra por la izquierda y la anterior sale por la derecha.
      var show = function (n, back) {
        var old = index;
        index = (n + slides.length) % slides.length;
        if (index === old) return;
        if (back) {
          // Coloca la entrante a la izquierda sin animar; la transición arranca desde ahí.
          var el = slides[index];
          el.style.transition = 'none'; el.style.transform = 'translateX(-100%)';
          void el.offsetWidth;
          el.style.transition = ''; el.style.transform = '';
        }
        slides.forEach(function (s, i) {
          s.classList.remove('is-active', 'is-prev');
          if (i === index) s.classList.add('is-active');
          else if (i === old && !back) s.classList.add('is-prev');   // hacia atrás sale por la derecha (posición por defecto)
        });
        lines.forEach(function (l, i) { l.classList.toggle('active', i === index); });
      };
      var gp = gallery.querySelector('.product-gallery-arrow.prev');
      var gn = gallery.querySelector('.product-gallery-arrow.next');
      if (gp) gp.addEventListener('click', function (e) { e.stopPropagation(); show(index - 1, true); });
      if (gn) gn.addEventListener('click', function (e) { e.stopPropagation(); show(index + 1); });
      lines.forEach(function (line, i) { line.addEventListener('click', function () { show(i, i < index); }); });

      // Deslizar en táctil (cliente 2026-10-02). Sólo cuenta un gesto claramente
      // horizontal (≥40 px y más ancho que alto): el vertical sigue siendo scroll de página.
      var tx = 0, ty = 0, swiped = false;
      gallery.addEventListener('touchstart', function (e) {
        tx = e.touches[0].clientX; ty = e.touches[0].clientY; swiped = false;
      }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (slides.length < 2) return;
        var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          swiped = true;
          show(dx < 0 ? index + 1 : index - 1, dx > 0);
        }
      }, { passive: true });
      // El toque que cierra un deslizamiento no abre el zoom (initLightbox escucha el click).
      gallery.addEventListener('click', function (e) {
        if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; }
      }, true);
    }

    // Favourite (visual)
    root.querySelectorAll('.product-fav').forEach(function (b) {
      /* El corazón lo gestiona el handler global de assets/theme.js (guarda en localStorage). */
    });

    // Accordions + info-expanded state (keeps the buy block visible)
    var detail = root.querySelector('.product-detail');
    var refresh = function () { if (detail) detail.classList.toggle('info-expanded', !!detail.querySelector('.product-accordion.is-open')); };
    root.querySelectorAll('.product-accordion button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var acc = btn.closest('.product-accordion');
        if (acc) acc.classList.toggle('is-open');
        setTimeout(refresh, 0);
      });
    });
    refresh();

    // Sticky add-to-cart: visible only while the real buy block is off-screen
    var buyBlock = root.querySelector('.product-buy-block');
    var bar = root.querySelector('[data-pdp-sticky]');
    var realAdd = root.querySelector('.product-buy-block .add-to-bag');
    var stickyAdd = root.querySelector('[data-pdp-sticky-add]');
    if (stickyAdd && realAdd) stickyAdd.addEventListener('click', function () { realAdd.click(); });
    if (buyBlock && bar) {
      var barObs = new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        bar.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
      }, { threshold: 0 });
      barObs.observe(buyBlock);
    }

    // Pack atelier: hover / focus / click a piece → big preview
    var atelier = root.querySelector('[data-pack-atelier]');
    var selectPack = function () {};
    if (atelier) {
      var pImg = atelier.querySelector('[data-pack-image]');
      var pName = atelier.querySelector('[data-pack-name]');
      var pQty = atelier.querySelector('[data-pack-qty]');
      var pieces = [].slice.call(atelier.querySelectorAll('[data-pack-piece]'));
      var selectPiece = function (btn) {
        if (!btn) return;
        pieces.forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
        var name = btn.getAttribute('data-name');
        if (pImg) { pImg.src = btn.getAttribute('data-src'); pImg.alt = name; }
        if (pName) { pName.textContent = name; pName.href = btn.getAttribute('data-url') || '#'; }
        var q = Number(btn.getAttribute('data-qty')) || 1;
        if (pQty) pQty.textContent = q + ' ' + atelier.getAttribute(q === 1 ? 'data-unit-one' : 'data-unit-other');
      };
      // On pack switch keep the same piece if the new pack has it, else the first one
      selectPack = function () {
        var cur = atelier.querySelector('[data-pack-piece][aria-current="true"]');
        var visible = [].slice.call(atelier.querySelectorAll('.product-set-includes-list.is-visible [data-pack-piece]'));
        var same = cur && visible.filter(function (b) { return b.getAttribute('data-name') === cur.getAttribute('data-name'); })[0];
        selectPiece(same || visible[0]);
      };
      pieces.forEach(function (btn) {
        btn.addEventListener('click', function () { selectPiece(btn); });
        btn.addEventListener('focus', function () { selectPiece(btn); });
        btn.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') selectPiece(btn); });
      });
      selectPack();
    }

    // Set layout: the piece-count buttons are a variant switcher + pack-rail toggle
    var options = [].slice.call(root.querySelectorAll('.bundle-option'));
    if (options.length) {
      var variantInput = root.querySelector('[data-variant-input]');
      var priceEl = root.querySelector('[data-bundle-price]');
      var labelEls = [].slice.call(root.querySelectorAll('[data-bundle-label]'));
      var stickyPrice = root.querySelector('[data-sticky-price]');
      var packs = [].slice.call(root.querySelectorAll('[data-pack-for]'));
      // La descripción del producto nombra un solo pack («Vajilla completa de 42 piezas»):
      // el número sigue al pack elegido.
      var descEls = [].slice.call(root.querySelectorAll('.product-short, .product-description'));
      var setDescCount = function (label) {
        var n = (label || '').match(/\d+/);
        if (!n) return;
        descEls.forEach(function (el) { el.innerHTML = el.innerHTML.replace(/\b\d+(\s+piezas)\b/gi, n[0] + '$1'); });
      };
      var activeOpt = root.querySelector('.bundle-option.is-active');
      if (activeOpt) setDescCount(activeOpt.getAttribute('data-label'));
      options.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var key = btn.getAttribute('data-pack-key');
          options.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          packs.forEach(function (p) { p.classList.toggle('is-visible', p.getAttribute('data-pack-for') === key); });
          root.querySelectorAll('[data-plazo-for]').forEach(function (p) { p.hidden = p.getAttribute('data-plazo-for') !== btn.getAttribute('data-variant-id'); });
          selectPack();
          if (priceEl) priceEl.textContent = btn.getAttribute('data-price');
          if (stickyPrice) stickyPrice.textContent = btn.getAttribute('data-price');
          labelEls.forEach(function (el) { el.textContent = btn.getAttribute('data-label'); });
          setDescCount(btn.getAttribute('data-label'));
          var vid = btn.getAttribute('data-variant-id');
          if (variantInput && vid) {
            variantInput.value = vid;
            history.replaceState(null, '', '?variant=' + vid);
          }
        });
      });
    }

    // «Tu pack contiene →»: baja con suavidad (respeta reducir movimiento).
    root.querySelectorAll('[data-pack-anchor]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById('tu-pack');
        if (!target) return;
        e.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    // Colour swatches jump to that colour's variant
    root.querySelectorAll('.color-dot[data-color-url]').forEach(function (dot) {
      dot.addEventListener('click', function () { window.location.href = dot.getAttribute('data-color-url'); });
    });
  }

  function initLightbox() {
    var lightbox = document.getElementById('productLightbox');
    var mainMedia = document.querySelector('.product-main-media');
    if (!lightbox || !mainMedia || lightbox.dataset.init) return;
    lightbox.dataset.init = '1';
    var scroller = lightbox.querySelector('.lightbox-scroll');
    var figures = [].slice.call(lightbox.querySelectorAll('figure'));
    var thumbs = [].slice.call(lightbox.querySelectorAll('.lightbox-thumbs button'));
    var dots = [].slice.call(lightbox.querySelectorAll('.lightbox-dots span'));
    var openAt = function (i) {
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { if (figures[i]) figures[i].scrollIntoView({ block: 'start', inline: 'start' }); });
    };
    var close = function () {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    mainMedia.addEventListener('click', function (e) {
      if (e.target.closest('button')) return;
      var actives = [].slice.call(mainMedia.querySelectorAll('.product-gallery-slide'));
      var active = actives.findIndex(function (x) { return x.classList.contains('is-active'); });
      openAt(Math.max(active, 0));
    });
    var cl = lightbox.querySelector('.lightbox-close');
    if (cl) cl.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lightbox.classList.contains('is-open')) close(); });
    thumbs.forEach(function (btn) { btn.addEventListener('click', function () { var idx = Number(btn.dataset.target || 0); if (figures[idx]) figures[idx].scrollIntoView({ behavior: 'smooth', block: 'start' }); }); });
    if (scroller) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) { var idx = Number(entry.target.dataset.index || 0); [thumbs, dots].forEach(function (set) { set.forEach(function (t, i) { t.classList.toggle('active', i === idx); }); }); } });
      }, { root: scroller, threshold: .6 });
      figures.forEach(function (f) { obs.observe(f); });
    }
  }

  document.querySelectorAll('.product-page').forEach(init);
  initLightbox();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.product-page').forEach(init);
    initLightbox();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCards(root) {
    root.querySelectorAll('.product').forEach(function (card) {
      if (card.dataset.cardLink) return;
      card.dataset.cardLink = '1';
      card.addEventListener('click', function (e) {
        if (e.target.closest('button')) return;
        var link = card.querySelector('.product-info a');
        if (link && link.href) window.location.href = link.href;
      });
    });
  }

  // Product Recommendations API via the Section Rendering API: swap the collection
  // grid for the real recommendations. Anything that comes back empty (e.g. `complementary`
  // with no products set in Search & Discovery) leaves the collection grid in place, so
  // the cross-sell row is never blank.
  function loadRecommendations(root) {
    var url = root.dataset.recommendations;
    if (!url) return;
    root.removeAttribute('data-recommendations');
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('.related-grid');
        var grid = root.querySelector('.related-grid');
        if (!grid || !next || !next.querySelector('.product')) return;
        grid.replaceWith(next);
        initCards(root);
        dedupeAcrossRows();
        // ponytail: let theme.js's shopify:section:load handler observe the new .reveal
        // cards instead of re-implementing the observer here (same as collection-grid).
        root.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      })
      .catch(function () {});
  }

  // Las dos filas de la PDP ("Completa la mesa" y "Te puede interesar") piden sus
  // recomendaciones por separado y no se ven entre si, asi que el mismo producto
  // puede caer en ambas. Se recorre el documento en orden y se quitan las tarjetas
  // repetidas: gana la primera fila. Es en cliente porque el contenido definitivo
  // llega del fetch, no del render de Liquid.
  function dedupeAcrossRows() {
    var seen = {};
    document.querySelectorAll('.product-related .related-grid .product').forEach(function (card) {
      var link = card.querySelector('.product-info a');
      var key = link && link.getAttribute('href');
      if (!key) return;
      key = key.split('?')[0];
      if (seen[key]) { card.remove(); return; }
      seen[key] = 1;
    });
    document.querySelectorAll('.product-related').forEach(function (row) {
      var grid = row.querySelector('.related-grid');
      row.hidden = !(grid && grid.querySelector('.product'));
    });
  }

  function init(root) {
    initCards(root);
    loadRecommendations(root);
    dedupeAcrossRows();
  }

  document.querySelectorAll('.product-related').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.product-related').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-scene"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.scene-redesign:not([data-init])').forEach(initScene);

  function initScene(root) {
    root.dataset.init = '1';
    const dataEl = root.querySelector('[data-scene-data]');
    const panel = root.querySelector('[data-scene-product]');
    const dots = root.querySelector('[data-scene-dots]');
    const status = root.querySelector('[data-scene-status]');
    const hotspots = [...root.querySelectorAll('[data-scene-hotspot]')];
    if (!dataEl || !panel || !dots) return;

    let data = {};
    try { data = JSON.parse(dataEl.textContent.trim()); } catch (e) { data = {}; }
    const items = data.items || [];
    const sets = data.sets || [];
    const cartUrl = data.cartUrl || '/cart/add';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!items.length) return;

    let current = 0;
    const N = items.length;

    function escapeHtml(value) {
      return String(value ?? '').replace(/[&<>"']/g, char => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
      })[char]);
    }

    // Real variant -> /cart/add form (intercepted globally by the cart drawer); demo -> inert button.
    function actionBtn(label, variant, alt) {
      if (!label) return '';
      const cls = 'ghost-btn small-cart' + (alt ? ' alt' : '');
      if (variant) {
        return `<form method="post" action="${escapeHtml(cartUrl)}"><input type="hidden" name="id" value="${escapeHtml(variant)}"><button class="${cls}" type="submit" name="add">${escapeHtml(label)}</button></form>`;
      }
      return `<button class="${cls}" type="button">${escapeHtml(label)}</button>`;
    }

    function slideHtml(p, index) {
      const imgHtml = p.img
        ? `<a class="scene-image-open" href="${escapeHtml(p.url || '#')}"><img src="${escapeHtml(p.img)}" alt="${escapeHtml(p.name || '')}" loading="lazy" decoding="async"></a>`
        : '';
      return `<article class="scene-slide" data-scene-slide="${index}">` +
        imgHtml +
        (p.meta ? `<p>${escapeHtml(p.meta)}</p>` : '') +
        `<h3>${escapeHtml(p.name || '')}</h3>` +
        (p.price ? `<span class="scene-price">${escapeHtml(p.price)}</span>` : '') +
        `<div class="scene-actions">` +
        actionBtn(data.addLabel, p.variant, false) +
        sets.map(s => actionBtn(s.label, s.variant, true)).join('') +
        `</div>` +
      `</article>`;
    }

    // One semantic copy is enough. It avoids duplicated links and forms while
    // native scroll-snap still provides touch, trackpad and keyboard movement.
    panel.innerHTML = items.map(slideHtml).join('');
    dots.innerHTML = items.map((item, i) =>
      `<button class="scene-dot${i === 0 ? ' active' : ''}" type="button" data-scene-dot="${i}" aria-label="${escapeHtml(item.name || `${i + 1}`)}" aria-current="${i === 0 ? 'true' : 'false'}"></button>`
    ).join('');

    let down = false, startX = 0, startLeft = 0, moved = false;
    let vx = 0, lastX = 0, lastT = 0, ticking = false, resizeT = 0;

    const width = () => panel.clientWidth || 1;
    const visibleIndex = () => Math.max(0, Math.min(N - 1, Math.round(panel.scrollLeft / width())));

    function update(index, announce) {
      current = Math.max(0, Math.min(N - 1, index));
      [...dots.children].forEach((dot, i) => {
        const active = i === current;
        dot.classList.toggle('active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      hotspots.forEach((hotspot, i) => {
        const active = i === current;
        hotspot.classList.toggle('active', active);
        hotspot.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (announce && status) status.textContent = items[current].name || `${current + 1}`;
    }

    function sync() {
      const i = visibleIndex();
      if (i === current) return;
      update(i, true);
    }

    panel.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => { ticking = false; sync(); });
      }
    }, { passive: true });

    function goToIndex(j) {
      const next = ((j % N) + N) % N;
      const wraps = Math.abs(next - current) > 1;
      update(next, true);
      panel.scrollTo({ left: next * width(), behavior: wraps || reduceMotion ? 'auto' : 'smooth' });
    }

    hotspots.forEach(h => h.addEventListener('click', () => goToIndex(Number(h.dataset.sceneHotspot))));
    root.querySelector('[data-scene-prev]')?.addEventListener('click', () => goToIndex(current - 1));
    root.querySelector('[data-scene-next]')?.addEventListener('click', () => goToIndex(current + 1));

    dots.addEventListener('click', e => {
      const dot = e.target.closest('[data-scene-dot]');
      if (!dot) return;
      goToIndex(Number(dot.dataset.sceneDot));
    });

    update(0, false);
    window.addEventListener('resize', () => {
      clearTimeout(resizeT);
      resizeT = setTimeout(() => { panel.scrollLeft = current * width(); }, 150);
    });

    // Native scrolling covers touch, trackpad, shift+wheel and keyboard. Mouse
    // click-drag is the one gesture no scroll container gives you, so add just
    // that and let the scroller keep owning the position.
    panel.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false;
      startX = lastX = e.clientX; startLeft = panel.scrollLeft;
      lastT = e.timeStamp; vx = 0;
      // user-select:none alone doesn't stop a selection the browser has already
      // begun on mousedown; preventDefault does. Form controls keep their default
      // so focus and clicks still behave.
      if (!e.target.closest('button, input, select, textarea')) e.preventDefault();
      // Snap fights a drag in progress, and smooth would animate every step.
      panel.style.scrollSnapType = 'none';
      panel.style.scrollBehavior = 'auto';
      panel.classList.add('is-dragging');
    });
    panel.addEventListener('pointermove', e => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      const dt = e.timeStamp - lastT;
      if (dt > 0) vx = (e.clientX - lastX) / dt;  // px/ms, positive = dragging right
      lastX = e.clientX; lastT = e.timeStamp;
      panel.scrollLeft = startLeft - dx;
    });
    function endDrag() {
      if (!down) return;
      down = false;
      panel.classList.remove('is-dragging');

      // Re-enabling snap here would jump, not glide, so pick the slide ourselves.
      // A fast flick carries to the next one even if it barely travelled;
      // otherwise the nearest wins, which is the usual past-halfway rule.
      const at = panel.scrollLeft / width();
      let target = Math.abs(vx) > 0.4 ? (vx < 0 ? Math.ceil(at) : Math.floor(at)) : Math.round(at);
      target = Math.max(0, Math.min(N - 1, target));
      panel.style.scrollSnapType = '';
      panel.style.scrollBehavior = '';
      update(target, true);
      panel.scrollTo({ left: target * width(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    panel.addEventListener('pointerup', endDrag);
    panel.addEventListener('pointercancel', endDrag);
    panel.addEventListener('pointerleave', endDrag);
    // Dragging an <img> or <a> starts a native HTML5 drag and eats the gesture.
    panel.addEventListener('dragstart', e => e.preventDefault());
    // Swallow the click that ends a drag so it doesn't open the product link.
    panel.addEventListener('click', e => {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.scene-redesign:not([data-init])').forEach(initScene);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stamp-archive"] && !Shopify.designMode) return;
  try {
    
(function () {
  // El archivo pesa ~57 KB entre datos y lógica, así que se carga solo aquí.
  function load() {
    var root = document.querySelector('[data-stamp-archive]');
    if (!root || root.dataset.archiveLoaded) return;
    root.dataset.archiveLoaded = '1';
    var s = document.createElement('script');
    s.src = root.dataset.archiveSrc;
    s.defer = true;
    document.head.appendChild(s);
  }
  load();
  document.addEventListener('shopify:section:load', load);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-scroll"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.story-scroll:not([data-init])');
  sections.forEach(initStory);

  function initStory(root) {
    root.dataset.init = '1';
    const sticky = root.querySelector('.story-scroll__sticky');
    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    function update() {
      const rect = root.getBoundingClientRect();
      /* v101: el alto del bloque fijo, no window.innerHeight: en iOS innerHeight cambia
         al plegarse la barra de Safari y el progreso daba saltos a mitad de scroll. */
      const max = Math.max(root.offsetHeight - (sticky ? sticky.offsetHeight : window.innerHeight), 1);
      const raw = clamp(-rect.top / max, 0, 1);
      const textOpacity = clamp((raw - 0.20) / 0.18, 0, 1);
      const dim = clamp((raw - 0.18) / 0.24, 0, 0.72);
      const styles = document.documentElement.style;
      styles.setProperty('--story-progress', raw.toFixed(3));
      styles.setProperty('--story-image-mix', clamp((raw - 0.06) / 0.46, 0, 1).toFixed(3));
      styles.setProperty('--story-dim', dim.toFixed(3));
      styles.setProperty('--story-text-opacity', textOpacity.toFixed(3));
      styles.setProperty('--story-text-y', `${(1 - textOpacity) * 22}px`);
    }

    let ticking = false;
    function tick() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { update(); ticking = false; });
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    update();
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.story-scroll:not([data-init])').forEach(initStory);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
(function () {
  var key = 'cartuja-welcome-popup-dismissed';

  function init(root) {
    root.querySelectorAll('[data-welcome-popup]').forEach(function (popup) {
      if (popup.dataset.ready) return;
      popup.dataset.ready = 'true';
      var status = popup.querySelector('[data-welcome-status]');
      var delay = (Number(popup.dataset.delay) || 0) * 1000;

      // Cerrado = no vuelve a salir en 30 min, en ninguna página.
      var ttl = 30 * 60 * 1000;
      function dismissed() {
        try { return Date.now() - Number(localStorage.getItem(key) || 0) < ttl; } catch (error) { return false; }
      }
      function loadFont() {
        if (document.getElementById('welcome-popup-font')) return;
        var link = document.createElement('link');
        link.id = 'welcome-popup-font';
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=Ibarra+Real+Nova:wght@400&display=swap';
        document.head.appendChild(link);
      }
      // Se retira sola a los 10 s (petición del cliente), salvo que el visitante
      // la esté usando: tocarla o entrar en el formulario lo cancela. En escritorio el
      // ratón encima solo la pausa: al salir vuelve a contar (antes la cancelaba para
      // siempre con solo cruzarla, y en escritorio no se iba nunca).
      var autoClose, used = false;
      function stopAutoClose() { clearTimeout(autoClose); }
      function startAutoClose() {
        stopAutoClose();
        if (!used && !popup.hidden && !(window.Shopify && Shopify.designMode)) autoClose = window.setTimeout(close, 10000);
      }
      ['focusin', 'touchstart'].forEach(function (type) {
        popup.addEventListener(type, function () { used = true; stopAutoClose(); }, { passive: true });
      });
      popup.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse') stopAutoClose(); });
      popup.addEventListener('pointerleave', function (event) { if (event.pointerType === 'mouse' && !popup.contains(document.activeElement)) startAutoClose(); });
      function open(manual) {
        if (!popup.isConnected) return;
        popup.hidden = false;
        requestAnimationFrame(function () { popup.classList.add('is-open'); });
        if (status) { status.focus(); return; }
        if (manual === true) { used = true; return; }
        startAutoClose();
      }
      function close() {
        stopAutoClose();
        try { localStorage.setItem(key, String(Date.now())); } catch (error) {}
        popup.classList.remove('is-open');
        popup.hidden = true;
      }

      var reopen = popup.parentElement.querySelector('[data-welcome-reopen]');
      if (reopen) reopen.addEventListener('click', function () { stopAutoClose(); loadFont(); open(true); });
      popup.querySelectorAll('[data-welcome-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !popup.hidden) close(); });

      if (status || (window.Shopify && Shopify.designMode)) { loadFont(); open(); }
      // En la cesta no: taparía la barra de pago en móvil.
      else if (!dismissed() && !document.body.classList.contains('template-cart')) { loadFont(); window.setTimeout(autoOpen, delay); }

      // No encima del menú móvil, el mega-menú ni la cesta abiertos: espera a que se cierren.
      function autoOpen() {
        var busy = document.body.classList.contains('menu-open') ||
          document.querySelector('#mobileDrawer.is-open, #cartDrawer[aria-hidden="false"]');
        if (busy) { window.setTimeout(autoOpen, 1500); return; }
        open();
      }
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:select', function (event) {
    var popup = event.target.querySelector('[data-welcome-popup]');
    if (popup && popup.hidden) { popup.hidden = false; popup.classList.add('is-open'); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
